export enum UserType {
  USER = 'user',
  ADMIN = 'admin',
}

export interface User {
  id?: string;
  name: string;
  lastName: string;
  email: string;
  type?: UserType;
  birthdate: Date;
  phone: string;
  password?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

